import React, { Component, useEffect, useState } from "react";
import ComponentForgotPasswordCreateMobile from "./ComponentForgotPasswordCreateMobile";
import ComponentForgotPasswordCreateWeb from "./ComponentForgotPasswordCreateWeb";
import { BrowserView, MobileView } from "react-device-detect";
import useAnalyticsEventTracker from "../../core/service/useAnalyticsEventTracker";
import ReactGA from "react-ga4";
const ComponentForgotPasswordCreate = () => {
  const gaEventTracker = useAnalyticsEventTracker(
    "ForgotPasswordCreatePassword"
  );
  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
      title: "Forgot Password Create Password",
    });
  }, []);
  return (
    <>
      <BrowserView>
        <ComponentForgotPasswordCreateWeb></ComponentForgotPasswordCreateWeb>
      </BrowserView>
      <MobileView>
        <ComponentForgotPasswordCreateMobile></ComponentForgotPasswordCreateMobile>
      </MobileView>
    </>
  );
};

export default ComponentForgotPasswordCreate;
